import type {
  CredentialsRequirementType,
  OAuthProviderType,
  ServerDeploymentType,
  ServerFeature,
} from '@affine/graphql';

export interface ServerMetadata {
  id: string;

  baseUrl: string;
}

export interface ServerConfig {
  serverName: string;
  features: ServerFeature[];
  oauthProviders: OAuthProviderType[];
  type: ServerDeploymentType;
  initialized?: boolean;
  version?: string;
  credentialsRequirement: CredentialsRequirementType;
}
export enum CloudProvider {
  TENCENT = 'TENCENT',
  ALIYUN = 'ALIYUN',
}

export enum EApiPrefix {
  DEVELOPMENT = 'development',
  DEV = 'dev',
  PROD = 'prod',
  PRODUCTION = 'production',
}
